type SessionListener = () => void;

const sessionInvalidatedListeners = new Set<SessionListener>();
const sessionRefreshRequestedListeners = new Set<SessionListener>();
const CSRF_STORAGE_KEY = 'ecovoz:csrf-token';

const addListener = (listeners: Set<SessionListener>, listener: SessionListener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const notify = (listeners: Set<SessionListener>): void => {
  listeners.forEach((listener) => listener());
};

export const onSessionInvalidated = (listener: SessionListener): (() => void) => {
  return addListener(sessionInvalidatedListeners, listener);
};

export const notifySessionInvalidated = (): void => {
  notify(sessionInvalidatedListeners);
};

export const onSessionRefreshRequested = (listener: SessionListener): (() => void) => {
  return addListener(sessionRefreshRequestedListeners, listener);
};

export const requestSessionRefresh = (): void => {
  notify(sessionRefreshRequestedListeners);
};

export const getCsrfToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const value = window.sessionStorage.getItem(CSRF_STORAGE_KEY);
    if (!value) {
      return null;
    }

    const normalized = value.trim();
    return normalized || null;
  } catch {
    return null;
  }
};

export const setCsrfToken = (token: string | null | undefined): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!token || !token.trim()) {
      window.sessionStorage.removeItem(CSRF_STORAGE_KEY);
      return;
    }

    window.sessionStorage.setItem(CSRF_STORAGE_KEY, token.trim());
  } catch {
    // noop: session storage may be blocked in some contexts
  }
};

export const clearCsrfToken = (): void => {
  setCsrfToken(null);
};
